/* Custom components to be used by the user as overrides */

const TypeArray = () => null;
TypeArray.displayName = 'TypeArray';

const TypeObject = () => null;
TypeObject.displayName = 'TypeObject';

const TypeString = () => null;
TypeString.displayName = 'TypeString';

const TypeInteger = () => null;
TypeInteger.displayName = 'TypeInteger';

const TypeNumber = () => null;
TypeNumber.displayName = 'TypeNumber';

export { TypeArray, TypeObject, TypeString, TypeInteger, TypeNumber };
